import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import LoadingOverlay from "~/components/LoadingOverlay";
import noop from "~/utils/noop";

interface EmbedContainerProps {
  iframeSrc?: string;
  loading?: boolean;
  error?: string | null;
  messageHandler?: (event: MessageEvent) => void;
}

const EmbedContainer = ({
  iframeSrc,
  loading,
  error,
  messageHandler = noop,
}: EmbedContainerProps) => {
  const [iframeLoading, setIframeLoading] = useState(true);

  useEffect(() => {
    window.addEventListener("message", messageHandler);
    return () => window.removeEventListener("message", messageHandler);
  }, [messageHandler]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        userSelect: "none",
        overflow: "hidden",
      }}
    >
      <LoadingOverlay when={!error && (loading || iframeLoading)} />
      {error ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            p: 3,
          }}
        >
          <Typography variant="body1">{error}</Typography>
        </Box>
      ) : (
        <Box
          key={iframeSrc}
          component="iframe"
          src={iframeSrc}
          sandbox="allow-same-origin allow-scripts allow-downloads allow-modals allow-forms allow-popups"
          onLoad={() => setIframeLoading(false)}
          width="100%"
          height="100%"
          border="none"
        />
      )}
    </Box>
  );
};

export default EmbedContainer;
